import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type BrandsForAccountQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type BrandsForAccountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, brands?: Array<{ __typename?: 'Brand', name?: string | null, libraryUrn?: string | null }> | null } | null };


export const BrandsForAccount = /*#__PURE__*/ gql`
    query BrandsForAccount($accountId: ID!) {
  account(by: {id: $accountId}) {
    id
    brands {
      name
      libraryUrn
    }
  }
}
    ` as unknown as DocumentNode<BrandsForAccountQuery, BrandsForAccountQueryVariables>;

          

          export const useBrandsForAccountQuery = (options?:QueryHookOptions<BrandsForAccountQuery, BrandsForAccountQueryVariables>) => useQuery(BrandsForAccount, options);

          

          export type BrandsForAccountQueryOptions = QueryHookOptions<BrandsForAccountQuery, BrandsForAccountQueryVariables>;

          

          export const useBrandsForAccountLazyQuery = (options?:LazyQueryHookOptions<BrandsForAccountQuery, BrandsForAccountQueryVariables>) => useLazyQuery(BrandsForAccount, options);

          

          export type BrandsForAccountQueryResult = ReturnType<typeof useBrandsForAccountQuery>;

          
